export var ReservationPaymentType;
(function (ReservationPaymentType) {
    ReservationPaymentType["PAYMENT_VENDOR"] = "PAYMENT_VENDOR";
    ReservationPaymentType["PAYMENT_CUSTOMER"] = "PAYMENT_CUSTOMER";
    ReservationPaymentType["REFUND"] = "REFUND";
})(ReservationPaymentType || (ReservationPaymentType = {}));
